import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix GBP icon. Exported from Figma (Bombiix 2026). */
const GBPIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M14 15.3327C14 15.3327 7 15.3327 6 15.3327C6.14879 15.3327 8 14.666 8 12.666C8 11.9508 8 11.225 8 9.99935M13.4118 6.66601C13.0686 6.02729 12.278 4.66602 10.6113 4.66602C8.94468 4.66602 8 5.99935 8 7.99935C8 8.37907 8 9.51131 8 9.99935M8 9.99935H6M8 9.99935H11.3333"
      stroke="currentColor"
    />
  </svg>
);

export default GBPIcon;
